let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ixtOF")).then(() => parcelRequire('f8gcV'));